import {enumType} from '../common/enumType';

const serverType = (id: string, name: string, supportsDir: boolean, caseSensitive: boolean) => ({
   id,
   name,
   supportsDir,
   caseSensitive,
});

export enum ServerTypesEnum {
   WINDOWS_UNIX = 'WINDOWS_UNIX',
   AS_400_IFS = 'AS_400_IFS',
   AS_400_LIB = 'AS_400_LIB',
   MVS_IFS = 'MVS_IFS',
}

export const ServerTypes = enumType({
   /**
    * A constant representing a Windows or Unix server.
    */
   [ServerTypesEnum.WINDOWS_UNIX]: serverType(
      ServerTypesEnum.WINDOWS_UNIX,
      'Windows/Unix',
      true,
      true
   ),
   /**
    * A constant representing an AS400 server with IFS file system.
    */
   [ServerTypesEnum.AS_400_IFS]: serverType(ServerTypesEnum.AS_400_IFS, 'AS400/IFS', true, true),
   /**
    * A constant representing an AS400 server with library file system.
    */
   [ServerTypesEnum.AS_400_LIB]: serverType(
      ServerTypesEnum.AS_400_LIB,
      'AS400/Library',
      false,
      false
   ),
   /**
    * A constant representing an MVS server with IFS file system.
    */
   [ServerTypesEnum.MVS_IFS]: serverType(ServerTypesEnum.MVS_IFS, 'MVS/IFS', true, true),
});

export const ServerModes = enumType({
   ACTIVE: 'Active',
   PASSIVE: 'Passive',
});

export const ImplicitExplicit = enumType({
   EXPLICIT: 'Explicit SSL',
   IMPLICIT: 'Implicit SSL',
});
